import axios from 'axios';

export default {
  state: {
    users_search: null,
    users: null,
    friends: null,
    offers: null,
    myoffers: null,
    filter: 'all',
  },
  mutations: {
    setUsersSearch(state, users) {
      state.users_search = users;
    },
    setUsers(state, users) {
      state.users = users;
    },
    setFriends(state, friends) {
      state.friends = friends;
    },
    setOffers(state, offer) {
      state.offers = offer;
    },
    setMyOffers(state, myoffer) {
      state.myoffers = myoffer;
    },
    setUser(state, user) {
      state.user = user;
    },
    setActiveEvent(state, active) {
      state.active = active;
    },
    changeMode(state, val) {
      state.map = val;
    },
  },
  actions: {
    async setUsersSearch({ commit }, search) {
      commit('setUsersSearch', search);
    },
    async getUsers({ commit }, params) {
      let result;
      await axios
        .post(`/api/users`, params)
        .then((response) => {
          result = response.data;
          commit('setUsers', result);
        })
      return result;
    },
    removeFriend({ commit, state }, friend) {
      commit, friend;
      let finded = state.friends.find((user) => user.id === friend);
      state.friends.splice(state.friends.indexOf(finded), 1);
    },
    async getFriends({ commit }, params) {
      let result;
      await axios
        .post(`/api/users/friends`, params)
        .then((response) => {
          result = response.data;
          commit('setFriends', result);
        })
      return result;
    },
    async getOffers({ commit }, params) {
      let result;
      await axios
        .post(`/api/users/offers`, params)
        .then((response) => {
          result = response.data;
          commit('setOffers', result);
        })
      return result;
    },
    async getMyOffers({ commit }, params) {
      let result;
      await axios
        .post(`/api/users/myoffers`, params)
        .then((response) => {
          result = response.data;
          commit('setMyOffers', result);
        })
      return result;
    }
  },
  getters: {
    getUsersSearch: (s) => s.users_search,
    getUsers: (s) => s.users,
    getFriends: (s) => s.friends,
    getOffers: (s) => s.offers,
    getMyOffers: (s) => s.myoffers
  },
};
